// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-bar-container-UsArK {
  flex: 1;
  height: 40px;
  max-width: 800px;
  display: flex;
  gap: 8px;
  align-items: center;
  border-radius: 40px;
  border: 1px solid var(--color-neutral-300);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  padding: 12px 4px 12px 12px;
  margin-right: 8px;
}

.search-bar-container-UsArK:focus-within {
  border-color: var(--color-neutral-800);
  box-shadow: 0 0 0 0.5px var(--color-neutral-800);
}

.search-bar-searchIcon-EZVyI {
  --size: 22px;
  color: var(--color-neutral-500);
  cursor: default;
}

.search-bar-input-Y8TBZ {
  display: block;
  flex: 1;
  font-size: 15px;
  border: none;
  outline: none;
}

.search-bar-clearIcon-dGnL3 {
  width: auto;
  height: auto;
  font-size: 20px;
  color: var(--color-neutral-700);
}`, "",{"version":3,"sources":["webpack://./src/components/search-bar/search-bar.module.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,wDAAwD;EACxD,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,OAAO;EACP,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC","sourcesContent":[".container {\n  flex: 1;\n  height: 40px;\n  max-width: 800px;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  border-radius: 40px;\n  border: 1px solid var(--color-neutral-300);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  padding: 12px 4px 12px 12px;\n  margin-right: 8px;\n}\n\n.container:focus-within {\n  border-color: var(--color-neutral-800);\n  box-shadow: 0 0 0 0.5px var(--color-neutral-800);\n}\n\n.searchIcon {\n  --size: 22px;\n  color: var(--color-neutral-500);\n  cursor: default;\n}\n\n.input {\n  display: block;\n  flex: 1;\n  font-size: 15px;\n  border: none;\n  outline: none;\n}\n\n.clearIcon {\n  width: auto;\n  height: auto;\n  font-size: 20px;\n  color: var(--color-neutral-700);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `search-bar-container-UsArK`,
	"searchIcon": `search-bar-searchIcon-EZVyI`,
	"input": `search-bar-input-Y8TBZ`,
	"clearIcon": `search-bar-clearIcon-dGnL3`
};
export default ___CSS_LOADER_EXPORT___;
